// Persist and query user "savings" (coupons used) in localStorage.
// This is per-browser: no auth required.

const KEY = 'ofertopolis_savings_v1';

export const getSavingsHistory = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch (e) {
    console.error('Failed to parse savings history from localStorage:', e);
    return [];
  }
};

const persist = (list) => {
  const trimmed = list.slice(0, 200);
  localStorage.setItem(KEY, JSON.stringify(trimmed));
  try {
    window.dispatchEvent(new CustomEvent('savingsUpdated'));
  } catch (e) {
    console.error('Failed to dispatch savingsUpdated event:', e);
  }
};

// Parse a discount value from a coupon.
// Returns the estimated peso amount saved.
// For percentage titles, uses the amount ref (purchase amount if known, else min_purchase).
export const parseDiscountAmount = (coupon, amountRef = null) => {
  const title = String(coupon?.title || '').replace(/,/g, '');
  const m = title.match(/(\d+(?:\.\d+)?)\s*(%?)/);
  if (!m) return 0;
  const num = parseFloat(m[1]);
  const isPercent = m[2] === '%';
  if (isPercent) {
    const ref = amountRef || coupon?.min_purchase || 0;
    let s = (ref * num) / 100;
    if (coupon?.max_discount) s = Math.min(s, coupon.max_discount);
    return Math.round(s);
  }
  let s = num;
  if (coupon?.max_discount) s = Math.min(s, coupon.max_discount);
  return Math.round(s);
};

export const addSaving = (coupon, opts = {}) => {
  const amount = opts.amountOverride != null
    ? Math.round(Number(opts.amountOverride))
    : parseDiscountAmount(coupon, opts.amountRef);
  if (!amount || amount <= 0) return null;
  const list = getSavingsHistory();
  // De-dupe: prevent adding the same coupon within the last 60s
  const now = Date.now();
  const recent = list.find(
    (s) => s.couponId === coupon.id && now - new Date(s.date).getTime() < 60 * 1000
  );
  if (recent) return recent;
  const entry = {
    id: `${now}-${Math.random().toString(36).slice(2, 6)}`,
    couponId: coupon.id,
    code: coupon.code || '',
    title: coupon.title || '',
    type: coupon.coupon_type || 'store',
    amount,
    date: new Date().toISOString(),
  };
  list.unshift(entry);
  persist(list);
  return entry;
};

export const clearSavings = () => {
  localStorage.removeItem(KEY);
  try {
    window.dispatchEvent(new CustomEvent('savingsUpdated'));
  } catch (e) {
    console.error('Failed to dispatch savingsUpdated event:', e);
  }
};

export const getStats = () => {
  const list = getSavingsHistory();
  const total = list.reduce((s, e) => s + (e.amount || 0), 0);
  const now = new Date();
  const thisMonth = list
    .filter((e) => {
      const d = new Date(e.date);
      return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
    })
    .reduce((s, e) => s + (e.amount || 0), 0);
  return { total, thisMonth, count: list.length };
};
